import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";
import MainHeader from "./_components/MainHeader";
import MainFooter from "./_components/MainFooter";
import { BaseUrlApi, ErrorMessage } from "../../lib/api";
import { toast } from "sonner";
import axios from "axios";

export default function MainRoot() {
  const { language } = useLanguage();

  const [settings, setSettings] = useState([]);
  const [loadingSettings, setLoadingSettings] = useState(true);
  const getAllSettings = async () => {
    try {
      const { data } = await axios.get(`${BaseUrlApi}/settings`);
      setSettings(data.data[data.data.length - 1]);
    } catch (error) {
      const result = ErrorMessage(error);
      if (typeof result !== "object")
        toast("Error", {
          description: result,
        });
    } finally {
      setLoadingSettings(false);
    }
  };

  useEffect(() => {
    getAllSettings();
  }, []);

  return (
    <main
      className="w-full flex flex-col"
      dir={language === "en" ? "ltr" : "rtl"}
    >
      <MainHeader settings={settings} loading={loadingSettings} />

      <div className="flex-1" dir={language === "en" ? "ltr" : "rtl"}>
        <Outlet />
      </div>

      <MainFooter settings={settings} />
    </main>
  );
}
